import React, { useCallback } from 'react'
import { Error } from 'components/Form'
import { TestAreaStyles, WrapField } from './Styled'
import './style.css'
import { TextareaAutosize } from '@mui/material'

const Textarea = (props) => {
    const
        { bg, minRows,onFocus, fontSize, fullHeight, textAlign, placeholder, input, className, gridArea, arrayIndex } = props,
        { onChange, value = null } = input

    const _onChange = useCallback((e) => {
        onChange(e.target.value, e);
    }, [onChange])

    return (
        <WrapField className={className} style={arrayIndex ? { gridArea: `${gridArea}_${arrayIndex}` } : {}}>
            <TestAreaStyles bg={bg} fontSize={fontSize} fullHeight={fullHeight} textAlign={textAlign}>
                <TextareaAutosize
                    dir="ltr"
                    minRows={minRows}
                    value={value}
                    placeholder={placeholder}
                    onChange={_onChange}
                />
            </TestAreaStyles>
            <Error {...props} />
        </WrapField>
    )
}

export default Textarea